import Vue from 'vue'
import VueRouter from 'vue-router'
import memberHome from '@/components/memberHome'
import dynamicShare from '@/components/share/dynamicShare'
import portalIndex from '@/components/portalIndex'
import invite_in from '@/components/invite/invite_in'
import dynamicShare_in from '@/components/share/dynamicShare_in'
import videoResource from '@/components/resource/videoResource'
import orderDetail from '@/components/order/orderDetail'
import exclusive from '@/components/operation/Exclusive'
import couponDetail from '@/components/cardCoupons/couponDetail'
import cottonCoupons from '@/components/cardCoupons/cottonCoupons'
import download from '@/components/download/download'
import deskDiaryDiscount from '@/components/cardCoupons/deskDiaryDiscount'
import deskDiaryShare from '@/components/share/deskDiaryShare'
import deskDiaryMode from '@/components/share/component/deskDiaryMode'
import deskDiaryDiscountCoupons from '@/components/cardCoupons/deskDiaryDiscountCoupons'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'hash',
    // mode:'history',
    // mode: 'history',
    base: __dirname,
    //路由映射map
    routes: [
      //     { path: '/', redirect: '/homePortal/portalIndex' },
      // { path: '*', redirect: '/homePortal/portalIndex' },
      {
	      path: '/memberHome',
	      name: 'memberHome',
	      component: memberHome,
	      children:[
          {
            path: '/homePortal/portalIndex',
            name: 'portalIndex',
            component: portalIndex
          },
          {
            path: '/share/dynamicShare',
            name: 'dynamicShare',
            component: dynamicShare
          },
          {
            path:'/homePortal/invite_in',
            name:'invite_in',
            component:invite_in
          },
          {
            path:'/homePortal/dynamicShare_in',
            name:'dynamicShare_in',
            component:dynamicShare_in
          },
          {
            path:'/video',
            name:'videoResource',
            component:videoResource
          },
          {
            path:'/orderDetail/:orderID',
            name:'orderDetail',
            component:orderDetail
          },
          {
            path:'/exclusive',
            name:'exclusive',
            component:exclusive
          },
          {
            path:'/couponDetail',
            name:'couponDetail',
            component:couponDetail
          },
          {
            path:'/cottonCoupons',
            name:'cottonCoupons',
            component:cottonCoupons
          },
          {
            path:'/deskDiaryDiscount',
            name:'deskDiaryDiscount',
            component:deskDiaryDiscount
          },
          {
            path:'/dowload_in',
            name:'download_in',
            component:download
          },
          {
            path:'/deskDiaryShare',
            name:'deskDiaryShare',
            component:deskDiaryShare
          },
          {
            path:'/deskDiaryMode',
            name:'deskDiaryMode',
            component:deskDiaryMode
          },
          {
            path:'/deskDiaryDiscountCoupons',
            name:'deskDiaryDiscountCoupons',
            component:deskDiaryDiscountCoupons
          }
	      ]
	    },

    ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js